
import React from "react"

import Layout2 from "../components/layout2"
import SEO from "../components/seo"
import App from "../components/appBettskena";

import InternLinks from "../components/internlinks";
import { Breadcrumb } from "../components/globals/breadcrumb";

const IndexPage = () => (
  <Layout2>
        <Breadcrumb category={["nyheter", "nyheter"]}  page={["Antibite", "antibite"]}/>
     <SEO title="Bettskena mot tandgnissling" description="Sluta gnissla tänder med bettskena" keywords={[`Bettskena`, `gnissla tänder`, `antibite`, `tandgnissling`, `2021`]}/>
     <section className="section-metoder">
     <main>
       <h1 class="welcome">Bettskena mot tandgnissling, huvudvärk och snarkning?</h1>
       <p class="text-center">
      Väldigt många svenskar gnisslar tänder, och man uppskattar att ca 500 000 påverkas i sin vardag.
      Lider du av huvudvärk och migrän när du vaknar? Då kan en bettskena hjälpa dig. 
      Bettskenan minskar påtryckningen och kontakten mellan tänderna, och avlastar även muskler och leder i ansiktet, 
      vilket gör att du slipper bekymmer när du vaknar. Dessutom kan bettskenan motverka snarkning, vilket inte bara hjälper dig, utan du får även en gladare sambo som också får en bättre nattsömn.
       </p>
       <h2 class="welcome">Hur fungerar en bettskena?</h2>
       <p class="text-center">
        En skena anpassas efter dina tänder genom en modell. Att ta fram en modell sker på olika vis, om du går till en tandläkare eller om du skaffar en egen via tex <a href="https://adr.ec/sgggg_fW" target="_blank" rel="noopener noreferrer">Antibite</a>. 
      En tandläkare gör ett avtryck av dina tänder till att börja med. Avtrycket kan göras med hjälp av en speciell massa som man biter i och som sen används som mall vid framtagningen av bettskenan.
      Numera är det vanligare att man använder en kamera med 3d-teknik för att göra avtrycket. Då för tandläkaren runt en kamera längs din tandrad som med hjälp av 3d-teknik kan visa avtrycket på en skärm i 3d-format.
      Därefter skickas mallen för tillverkning som brukar ta upp till tre veckor.
      Om du köper en bettskena via <a href="https://adr.ec/sgggg_fW" target="_blank" rel="noopener noreferrer">Antibite</a>, så anpassas den efter dina tänder genom att den först doppas i kokande vatten.
      Oavsett så blir skenan unik och anpassas efter dina tänder. Med skenan placerad över tänderna kommer du inte längre att kunna gnissla tänder men du sover.</p>
      <h2 class="welcome">Hur rengör man sin bettskena?</h2>
      <p class="text-center">
      Din bettskena slits ner och blir ohygienisk efter ett tag, och därför rekommenderas att du byter ut den ungefär var sjätte månad. Men det finns några saker 
      man kan göra för att den ska hålla sig fräsch och kanske hålla lite längre. 
            <ul style={{listStyleType: "none"}}>
        <li>På morgonen tar du ut bettskenan och sköljer den i ljummet vatten med flytande tvål eller diskmedel.</li>
        <li>Efter några veckor kan det fastna mineraler, liknande tandsten och då kan du lägga den i ett glas med vatten och ättika i lika delar, som då löser upp beläggningen. Du kan använda en tandborste också om det inte lossnar helt.</li>
        <li>Desinfektera inte bettskenan genom att koka den för det skadar den och använd inte tandkräm eftersom tandkräm har en slipande effekt.</li>
        <li>Ej synlig för småbarn eller husdjur. Bettskenan är nämligen lockande att bita på.</li>
        <li>Förvara den i vatten för att förhindra att plasten i skenan förändras.</li>
      </ul>
      </p>
             
</main>
</section>
<section className="section-cards">
      <main className="card__ai">
        <h2 class="card-rubrik">Bettskena</h2>
        <App />
        </main>
</section>
     <section className="section-metoder">
     <main>
      <h2 class="welcome">Vad är för pris på en bettskena?</h2>
      <p class="text-center">Går du till en tandläkare kan priset hamna mellan ca 3000 - 5000:-. Förutom priset så krävs det en eller 
      två konsultationer med tandläkaren. Så det går att spara tid och pengar genom att göra det själv. Du får väl ut samma fördelar, men 
      en bettskena hos en tandläkare kan hålla lite längre.</p>
     </main>
     </section>

<section className="section-cards card-height">
  <main>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </main>
  </section>
  </Layout2>
)

export default IndexPage
